module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detailsBox",
    class: {
      'showDetailsBox': _vm.state
    }
  }, [_c('div', {
    staticClass: "detailsBoxContent"
  }, [_c('div', {
    staticClass: "Title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "BoxContent"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "closeBut",
    on: {
      "click": _vm.switchFn
    }
  }, [_c('span', [_vm._v("X")])])]), _vm._v(" "), _c('div', {
    staticClass: "Module"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b3376c2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/detailsBox/src/detailsBox.vue
// module id = 505
// module chunks = 0